
import axios from 'axios';
import styled from 'styled-components';
import { PointsContext } from './pointContext';

import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from "chart.js/auto";
import { useState, Fragment, createContext, useContext  } from 'react';
const NavContainer = styled.div`
  grid-area: team;
  display: flex;
  align-items: center;
  min-height:10vh;
  background-color: #1A1D20;
  overflow-y:auto;
  margin: 0 auto;
  width:100%;
`;

const DropdownButton = styled.button`
  background-color: #1E2224;
  color: white;
  padding: 10px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
`;



const DropdownContent = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  max-height: 200px;  /* Adjust this value as needed */
  overflow-y: auto;
  transition: max-height 1.3s ease-in-out;  /* Add this line for smooth transition */
`;

const ListItem = styled.li`
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #ddd;
  }
  transition: background-color 1.3s ease;  /* Add this line for smooth hover effect */
`;

const SelectionList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
    color:black;

`;

const OpenButton = styled.button`
 display: ${props => (props.show ? 'flex' : 'flex')};
  background-color: transparent;
  border: none;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
  float: right;
  margin: 1.2px;
  padding-right:140px;
`;



const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  float: right;
  margin: 5px;
`;

const BoxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color:#4A5055;
  margin-left: 20px;
  padding-top:30px;
  height:  ${props => (props.show ? '25vh' : '20vh')};
  width:  ${props => (props.show ? '100%' : '100%')};
  overflow-x:auto;
  overflow-y:auto;
`;

const Box = styled.div`
  background-color: #1E2224;
  color: white;
  padding: .4rem;
  margin: .25rem;
  border-radius: .15rem;
  font-size:1rem;
  &:hover {
    background-color: grey
  }
`;
const ParentBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Creates two columns, each taking 1 fraction (half) of the available space */
  width: 100%; /* Occupy full viewport width */
  min-width:100%;
  background-color: #f0f0f0; /* Light grey background for parent */
`;


const ChildBox = styled.div`
  background-color: #4A5055;
  display: flex;
  justify-content: center;
  align-items: center;

  /* --- 3D Enhancements --- */
  border: 1px solid #5A6066; /* A slightly lighter border for definition */
  border-radius: 8px; /* Rounded corners for a softer, modern look */
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.2), /* Main shadow for depth */
    0 0 0 1px rgba(255, 255, 255, 0.05); /* Very subtle inner highlight */
  padding: 15px; /* Add some padding to give content space */
  margin: 5px; /* Add some margin if it's within a grid/flex container */
`;
const DemoSportNavBar = ({ itemss, setTeamNames , setPlayerNames}) => {
  // const { setTeamNames{} = useContext(PriceContext);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showTeamdown, setTeamDropdown] = useState(false);
  const { setPlayerName} = useContext(PointsContext);


    const teams = [
      //mens nba
// 'ATL', 'BOS', 'BRK', 'CHI', 'CHO', 'CLE', 'DAL', 'DEN', 'DET', 'GSW', 'MIA'
    //womens wnba 
    "ATL","CHI","CON","DAL","GSV","IND","LAS","LVA","MIN","NYL","PHO","POR","SEA","TOR","WAS"

    ];

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleClose = () => {
    setShowDropdown(false);
  };


  const handleWiden = () => {
    setTeamDropdown(!showTeamdown);
  };

  async function load_players (x) {
//////////////////////
let team = x
axios({
  method: 'post',
  url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
  withCredentials: false,
  data: {
  team:team,
    path:'team-data'
  },
}).then(function (response) {
  let player_list = []
  let data = response.data

  for (let i = 0; i < data.length; i++) {
    let p = data[i].starters
    player_list.push(p)
  }
  player_list =player_list.sort()
setPlayerNames(player_list)
  

})
.catch(function (error) {
});




   /////////////////// 

  

  }


  const handleTeamClick = (nteamn) => {

    setTeamNames(nteamn)
    load_players(nteamn)
    setShowDropdown(false);
  };

  function handleEmpty(){
  setPlayerNames([])
  }

  return (
    <NavContainer>
       <ParentBox>
      <ChildBox>
      <DropdownButton onClick={handleDropdownToggle}>
        Select Team
      </DropdownButton>
      <DropdownContent show={showDropdown}>
        <CloseButton onClick={handleClose}>x</CloseButton>
        <SelectionList>
          {teams.map((team, index) => (
            <ListItem key={index} onClick={() => handleTeamClick(team)}>
              {team}
            </ListItem>
          ))}
        </SelectionList>
      </DropdownContent>

      </ChildBox>
      <ChildBox>
      <BoxContainer show ={showTeamdown}>
      <OpenButton show={showDropdown} onClick={handleWiden}>x</OpenButton>

        {itemss.map((item, index) => (
          <Box key={index} onClick={() => setPlayerName(item)}>{item}</Box>
        ))}
                <CloseButton onClick={handleEmpty}>x</CloseButton>

      </BoxContainer>
      </ChildBox>
    </ParentBox>
      
 
 
    </NavContainer>
  );
};




export default DemoSportNavBar